<template>
  <b-sidebar
      v-model="modalOpen"
      v-if="modalOpen"
      centered
      id="branchModal"
      class="edit-modal"
      width="500px"
      backdrop
      no-close-on-backdrop
      no-close-on-esc
      no-header
      body-class="bg-white"
  >


    <div class="p-2">
      <validation-observer ref="branchValidation">
        <b-form @submit.prevent="onSubmit">
          <b-row>
            <b-col class="d-flex justify-content-between" cols="12">
              <h3> {{ mainTitle }} </h3>
              <feather-icon
                  size="20"
                  class="cursor-pointer"
                  @click="modalOpen = false"
                  icon="XIcon"
              />
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col cols="12" class="mt-1">
              <form-input
                  v-model="form.event_type"
                  rules="required"
                  label="نوع الفعالية"
                  :charsCount="10"
              />
            </b-col>
            <b-col cols="12" class="mt-1">
              <form-file-input
                  placeholder="اختر ملفاً"
                  id="invitation_file"
                  label="صورة عن الدعوة"
                  accept=".doc,.pdf,.docx"
                  v-model="form.invitation_file"
                  rules="required"
              />
            </b-col>
            <b-col cols="12">
              <form-select
                  rules="required"
                  label="رقم المحضر"
                  id="meeting_minute"
                  v-model="form.meeting_minute_id"
                  :getOptionLabel="(x) => x.meeting_minutes_label"
                  :reduce="(x) => x"
                  ep="v2/selects/meeting-minutes"
              />
              
              <small class="text-secondary mb-1 d-block" style="margin-top: -10px;">
                في حال عدم وجود محضر الاجتماع يُرجى تقديم معاملة بالمحضر الجديد
              </small>
            </b-col>
            <b-col cols="12">
              <form-mask
                  options="date"
                  placeholder="YYYY-MM-DD"
                  style="height: 37.5px !important"
                  v-model="form.start_date"
                  label="تاريخ بدء الفعالية"
                  rules="required"
                  class="w-25"
              />
            </b-col>
            <b-col cols="12">
              <form-mask
                  options="date"
                  placeholder="YYYY-MM-DD"
                  style="height: 37.5px !important"
                  v-model="form.end_date"
                  label="تاريخ نهاية الفعالية"
                  rules="required"
                  class="w-25"
              />
            </b-col>
            <b-col cols="12">
              <form-select
                rules="required"
                label="الدولة"
                id="country"
                v-model="form.country_id"
                :reduce="(x) => x"
                :getOptionLabel="(x) => x.name"
                ep="v2/guest/selects/countries"
              />
            </b-col>
            <b-col cols="12">
              <form-input
                v-model="form.address"
                rules="required"
                label=" العنوان"
              />
            </b-col>
            <b-col cols="12">
              <form-input
                  v-model="form.organiser"
                  rules="required"
                  label="الجهة المنظمة للفعالية"
                  :charsCount="10"
              />
            </b-col>
            <b-col cols="12">
              <form-textarea
                  v-model="form.objective"
                  rules="required"
                  label="الهدف من الفعالية"
                  :charsCount="10"
              />
            </b-col>
            <b-col cols="12">
              <form-textarea
                v-model="form.other_invited_parties"
                label="الجهات الإخرى المدعوة للفعالية"
              />
            </b-col>
          </b-row>
          <hr />

          <b-row class="px-1 justify-content-end">
            <b-button @click="modalOpen = false" class="mx-1">إلغاء</b-button>
            <save-btn
                type="submit"
                variant="success"
                :loading="loading"
                :label="btnLabel"
            >
            </save-btn>
          </b-row>
        </b-form>
      </validation-observer>
    </div>
  </b-sidebar>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BModal,
  BFormGroup,
  BFormFile,
  BFormRadio,
  BForm,
  BFormTextarea,
  BButton,
  BSidebar,
  BFormCheckbox
} from "bootstrap-vue";
import { ValidationObserver } from "vee-validate";
import formSelect from "@/components/form-select";
import formInput from "@/components/form-input";
import formTextarea from "@/components/form-textarea";
import saveBtn from "@/components/loader-btn";
import FormMask from "@/components/form-mask";
import { required, integer } from "@validations";
import mapSelect from "@/components/map-select";
import { ValidationProvider } from "vee-validate";
import FormImageInput from "@/components/FormImageInput.vue";
import { quillEditor } from "vue-quill-editor";
import FormFileInput from "@/components/FormFileInput.vue";
const initForm = {};
export default {
  components: {
    formInput,
    formTextarea,
    formSelect,
    BButton,
    BSidebar,
    FormMask,
    saveBtn,
    BRow,
    BCol,
    mapSelect,
    BCard,
    BCardText,
    BCardTitle,
    BModal,
    BFormGroup,
    BFormFile,
    BForm,
    BFormRadio,
    BFormTextarea,
    ValidationObserver,
    ValidationProvider,
    FormImageInput ,
    quillEditor ,
    FormFileInput ,
    BFormCheckbox
  },
  props: {
    value: Boolean,
    title: String,
    mainTitle: {
      type: String,
      default: () => "بياناتت المعاملة",
    },
    btnLabel: String,
    loading: Boolean,
    intializeForm: {
      type: Object,
      default: () => initForm,
    },
  },
  data() {
    return {
      form: {},
      required,
      integer,
    };
  },
  computed: {
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
  watch: {
    modalOpen(val) {
      if (val)
        this.$nextTick(() => {
          // this.init(this.intializeForm);
        });
    },
  },

  methods: {
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
    },
    async onSubmit() {
      await this.$refs.branchValidation.validate().then(async (success) => {
        if (success) {
          this.$emit("confirm", this.form);
        }
      });
    },
  },
};
</script>
